<template>
  <div class="show-box">
    <a-tooltip :title="data[propName]?.length > 18 ? data[propName] : ''" placement="top">
      <div
          ref="btnRef"
          :data-clipboard-text="data[propName] || ''"
          @click="onCopy"
      >
        {{ ellipsis(data[propName] || '', 18) }}
      </div>
    </a-tooltip>
  </div>
</template>

<script lang="ts" setup>
import {defineProps, onMounted, ref} from 'vue';
import {UrlFieldType} from '@/components/business/crud/interface/FieldType';
import ClipboardJS from "clipboard";
import {message} from "ant-design-vue";
import {WidgetInfo} from "@/components/business/crud/widgets/WidgetContainer";
import { ColumnEdit } from '@/components/business/crud/widgets/TableWidgetContainer';

const props = defineProps<{
  columnEdit?: ColumnEdit;
  propName: string;
  widget: UrlFieldType;
  info: WidgetInfo;
  data: any;
}>();

const btnRef = ref<HTMLElement>();

onMounted(() => {
  if (btnRef.value) {
    new ClipboardJS(btnRef.value);
  }
})

function ellipsis(text: string, max: number) {
  if (text.length <= max) {
    return text;
  } else {
    return text.slice(0, max - 3) + "..."
  }
}
function onCopy() {
  message.success('已复制');
}
</script>

<style lang="scss" scoped>
.show-box {
  height: 100%;
  display: flex;
  flex-direction: row;
  align-items: center;
}
</style>
